import React from 'react';
import { useMeasure } from 'react-use';
import PanelSizer from './PanelSizer';

const PanelMeasure = ({
  configuration,
  component,
  onChange,
  width = 400,
}) => {
  const [ref, dimensions] = useMeasure();

  return (
    <div ref={ref} className="aridhia-panel-measure">
      <PanelSizer
        configuration={configuration}
        onChange={onChange}
        dimensions={dimensions}
        component={component}
        width={width}
      />
    </div>
  );
};

export default PanelMeasure;
